import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { IModalWindow } from '@hooks/useModalWindow';
import React from 'react';

export type VendedorInventarioFilterProps = {
    isLoading: boolean
    selectedIds: number[],
    confirmModal: IModalWindow
}

export function VendedorInventarioFilter ({ isLoading, selectedIds, confirmModal }: VendedorInventarioFilterProps) {
    return (
        <FilterBar>
            <GridItem>
                <PrimaryButton onClick={confirmModal.open} disabled={isLoading || selectedIds.length === 0}>Resgatar</PrimaryButton>
            </GridItem>
        </FilterBar>
    )
}